"use client";

import { LanguageProvider } from "@/lib/language-context";
import { SettingsProvider } from "@/lib/settings-context";
import { PasswordGate } from "./password-gate";
import { PWARegister } from "./pwa-register";
import { AnalyticsProvider } from "./analytics-provider";
import type { ReactNode } from "react";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <LanguageProvider>
      <PasswordGate>
        <SettingsProvider>
          <AnalyticsProvider>
            {children}
            <PWARegister />
          </AnalyticsProvider>
        </SettingsProvider>
      </PasswordGate>
    </LanguageProvider>
  );
}
